import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { matches } from 'redux/modules'
import Loader from './Loader'

const MatchLoader = props => {
  const { children, matchId, fetchMatch, ...restProps } = props

  const fetchMethod = params => fetchMatch(matchId, params)
  const triggers = [matchId]

  return (
    <Loader fetchMethod={fetchMethod} triggers={triggers} {...restProps}>
      {children}
    </Loader>
  )
}

MatchLoader.propTypes = {
  children: PropTypes.node.isRequired,
  matchId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  fetchMatch: PropTypes.func.isRequired,
}

export default connect(
  null,
  { fetchMatch: matches.fetchMatch }
)(MatchLoader)
